import { Flex } from "antd";
import { BaseMobileHeader } from "@/common";
import { NotesListV2 } from "@/entities/notes-list-v2";
import { NotesManagerHeader } from "@/entities/notes-manager-header";
import { AppDrawer } from "@/shared/Components/AppDrawer";
import { NoteEditorMobile } from "@/features/NoteEditor/Components/Layout/mobile";
import { DeleteNotesModal } from "@/entities/delete-notes-modal";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { useContainerHeight } from "@/shared/hooks";
import { AddNoteButton } from "@/entities/add-note-button";
import { InputSearch } from "@/shared/Components";
import { getHeaderTitle, type NotesManagerProps } from "@/features/notes-manager/model";
import styles from "./styles.module.scss";

export const Mobile = ({ notesManager, noteType, contactsPage }: NotesManagerProps) => {
  const { containerRef, containerHeight } = useContainerHeight();

  const { state, methods, filters } = notesManager;

  const {
    notesTableData,
    selectedIds,
    swipedNote,
    deleteDisabled,
    selectedNotes,
    selectedTableNotes,
    deleteModalIsOpen,
    sorter,
    stringFilter,
  } = state;
  const {
    handleClickRow,
    handleOpenModal,
    handleCloseModal,
    onSelectChange,
    upsertNote,
    deleteNoteFileById,
    setSelectedNotes,
    setSwipedNote,
    deleteSelected,
    handleAddTempNote,
    setStringFilter,
  } = methods;

  return (
    <div className={styles.root} ref={containerRef}>
      <Flex className={styles["header"]} vertical gap={12}>
        <BaseMobileHeader
          title={getHeaderTitle(noteType)}
          onSorterMenuChange={filters.setSorter}
          sorterMenuValue={sorter}
          showSorter
        />
        <InputSearch
          className={styles[`${contactsPage ? "contacts-note-search" : ""}`]}
          value={stringFilter}
          onChange={(e) => setStringFilter(e.target.value)}
        />
      </Flex>
      <div
        style={{
          height: `${containerHeight}px`,
          overflow: window.innerWidth > 500 ? "hidden" : "auto",
        }}
      >
        <NotesManagerHeader
          disabledButton={deleteDisabled}
          onDeleteButtonClick={handleOpenModal}
          isShowHeader
        />
        <NotesListV2
          selectedNotesIds={selectedIds}
          cardsData={notesTableData ?? []}
          onClickCardEdit={(cardData) => {
            if (!selectedIds.find((id) => id === cardData.id)) {
              handleClickRow(cardData);
              onSelectChange([...selectedIds, cardData.id]);
              return;
            }
            handleClickRow(cardData);
          }}
          onAvatarClick={(cardData) => {
            if (selectedIds.find((id) => id === cardData.id)) {
              onSelectChange(selectedIds.filter((id) => id !== cardData.id));
              return;
            }
          }}
          onLongPress={(cardData) => {
            setSelectedNotes([]);
            if (selectedIds.find((id) => id === cardData.id)) {
              onSelectChange(selectedIds.filter((id) => id !== cardData.id));
              return;
            }
            onSelectChange([...selectedIds, cardData.id]);
          }}
          onClickCardDelete={(cardData) => {
            handleOpenModal();
            setSelectedNotes([]);
            onSelectChange([cardData.id]);
          }}
          onChangeCardStatus={(cardData, status) => {
            upsertNote({ ...cardData, status: status });
          }}
          swipedNote={swipedNote}
          setSwipedNote={setSwipedNote}
        />
      </div>
      <AppDrawer
        placement="bottom"
        open={
          !!(selectedIds.length && selectedNotes.length) ||
          !!selectedNotes.find((note) => note.id.includes("new"))
        }
        closable={false}
        height={`${window.innerHeight - 70}px`}
        onClose={() => {
          setSelectedNotes([]);
          onSelectChange([]);
        }}
        rootClassName={styles.drawer}
        autoFocus
        destroyOnClose
      >
        <NoteEditorMobile
          currentNote={selectedNotes.find((note) => note.id.includes("new")) ?? selectedNotes[0]}
          noteType={selectedNotes[0]?.noteType.name}
          onSubmit={upsertNote}
          deleteNoteFileById={deleteNoteFileById}
        />
      </AppDrawer>
      <DeleteNotesModal
        notes={selectedTableNotes}
        onConfirm={deleteSelected}
        onCancel={handleCloseModal}
        open={deleteModalIsOpen}
        noteType={DEFAULT_NOTE_TYPES.DEFAULT_NOTE}
      />
      <div className={styles["add-button"]}>
        <AddNoteButton onClick={handleAddTempNote} />
      </div>
    </div>
  );
};
